import React, { useContext } from 'react'
import classNames from 'classnames'

import { Icon } from '@scentregroup/ui'

import { User } from '../../../../types/user'
import { incBaseIdentity } from '../../../helpers/paths'
import { LinkContext } from '../context'

import style from './index.module.scss'
import Nav from '.'

const Account: React.FC<{
  from?: string
  redirect?: string
  user?: User
  onClose: () => void
}> = ({ from = '', redirect, user, onClose }) => {
  const Link = useContext(LinkContext)
  const path =
    redirect || `${location.pathname}${location.search}${location.hash}`

  // eslint-disable-next-line compat/compat
  const searchParams = new URLSearchParams({ path })

  if (from !== '') {
    searchParams.append('from', from)
  }

  const loginUrl = `${incBaseIdentity('login')}?${searchParams.toString()}`
  const signupUrl = `${incBaseIdentity('register')}?${searchParams.toString()}`
  const logoutUrl = `${incBaseIdentity('logout')}?${searchParams.toString()}`

  const items = user
    ? [
        () => (
          <div
            className={classNames(style.item, style['item-big'])}
            data-test-id="main-navdrawer-welcome-message"
          >
            {user.firstName ? `Hi, ${user.firstName}!` : 'Hi!'}
          </div>
        ),
        { label: 'Account', url: incBaseIdentity(`account-info`) },
        { label: 'Orders', url: incBaseIdentity(`account-info/orders`) },
        {
          label: 'Payment methods',
          url: incBaseIdentity(`account-info/payment-methods`),
        },
        { label: 'Sign out', url: logoutUrl },
      ]
    : [
        {
          label: 'Login',
          url: loginUrl,
          className: classNames(style['item-big']),
        },
        {
          label: 'Sign up',
          url: signupUrl,
          className: classNames(style['item-big']),
        },
        () => (
          <>
            <div className={classNames(style.item, style.title)}>
              You get more with Westfield Plus
            </div>
            <div className={classNames(style.item)}>
              <Icon
                size="medium"
                type="wallet"
                className={classNames(style.icon)}
              />
              <span>Earn rewards when you Click & Collect</span>
            </div>
            <div className={classNames(style.item)}>
              <Icon
                size="medium"
                type="delivery"
                className={classNames(style.icon)}
              />
              <span>Free delivery for orders $50 and over</span>
            </div>
            <div className={classNames(style.item)}>
              <Icon
                size="medium"
                type="westfield-direct-returns"
                className={classNames(style.icon)}
              />
              <span>Free and easy returns</span>
            </div>
          </>
        ),
        () => (
          <Link
            target="_blank"
            rel="noopener noreferrer"
            to={'/westfield-plus'}
            className={classNames(style.link, style.learnMoreLink, style.item)}
          >
            Learn more
          </Link>
        ),
      ]

  return (
    <Nav
      className={classNames(style['nav-reverse'])}
      items={items}
      onClose={onClose}
    />
  )
}

export default Account
